import React, { useState } from 'react';
import axios from 'axios';
import API_BASE from '../api';

const LINK_BLUE = '#2563eb';
const BTN_BLUE = '#2563eb';

/** Same layout as coach-selection completion: logo, green headline, grey copy. No motion. */
export function DeclineMatchThankYouScreen() {
  return (
    <div className="completion-screen match-results-page">
      <div style={{
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '1.25rem',
      }}>
        <img src="/logo-letterly.png" alt="Letterly" style={{ height: 56, marginBottom: '0.25rem' }} />
        <p style={{ fontWeight: 700, color: '#166534', fontSize: '1.5rem', margin: 0 }}>
          Thank you!
        </p>
        <p style={{ color: '#6b7280', fontSize: '0.95rem', margin: 0, maxWidth: 480, lineHeight: 1.65 }}>
          Please allow for 24-48 hours as our team reviews your request. We&apos;ll take another look at your comments and follow up using the contact information you shared.
        </p>
      </div>
    </div>
  );
}

export default function DeclineCoachMatches({ requestId, onComplete }) {
  const [expanded, setExpanded] = useState(false);
  const [reason, setReason] = useState('');
  const [contact, setContact] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  if (!requestId) return null;

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    const r = reason.trim();
    const c = contact.trim();
    if (!r) {
      setError('Please tell us why these options don\'t work.');
      return;
    }
    if (!c) {
      setError('Please add a phone number or WeChat / WhatsApp ID.');
      return;
    }
    setSubmitting(true);
    try {
      await axios.post(`${API_BASE}/api/intake/decline-matches`, {
        request_id: requestId,
        reason: r,
        contact: c,
      });
      onComplete?.();
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{ marginTop: '2rem', maxWidth: 560 }}>
      {!expanded && (
        <button
          type="button"
          onClick={() => setExpanded(true)}
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
            color: LINK_BLUE,
            fontSize: '0.9rem',
            fontWeight: 600,
            cursor: 'pointer',
            textDecoration: 'underline',
          }}
        >
          None of these coach options work for me
        </button>
      )}

      {expanded && (
        <div style={{
          border: '1px solid #e5e7eb',
          borderRadius: 10,
          padding: '1.25rem 1.35rem',
          background: '#fafafa',
        }}>
          <form onSubmit={submit}>
            <h3 style={{ margin: '0 0 0.5rem', fontSize: '1rem', fontWeight: 700, color: '#111827' }}>
              Tell us what isn&apos;t working
            </h3>
            <p style={{ margin: '0 0 1rem', fontSize: '0.88rem', color: '#6b7280', lineHeight: 1.55 }}>
              Let us know why these options aren&apos;t a fit, and our team will review your request. Please include the best way to reach you if a follow-up is needed.
            </p>
            {error && (
              <div style={{ marginBottom: '0.75rem', fontSize: '0.85rem', color: '#b91c1c' }}>{error}</div>
            )}
            <label style={{ display: 'block', fontWeight: 600, fontSize: '0.82rem', color: '#374151', marginBottom: '0.35rem' }}>
              Feedback
            </label>
            <textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Why don't these options work for you?"
              rows={4}
              style={{
                width: '100%',
                boxSizing: 'border-box',
                border: '1px solid #d1d5db',
                borderRadius: 8,
                padding: '0.65rem 0.75rem',
                fontSize: '0.9rem',
                fontFamily: 'inherit',
                marginBottom: '1rem',
                resize: 'vertical',
              }}
            />
            <label style={{ display: 'block', fontWeight: 600, fontSize: '0.82rem', color: '#374151', marginBottom: '0.35rem' }}>
              How to reach you
            </label>
            <input
              type="text"
              value={contact}
              onChange={(e) => setContact(e.target.value)}
              placeholder="What is the best phone number of WeChat / Whatsapp ID to reach you at?"
              style={{
                width: '100%',
                boxSizing: 'border-box',
                border: '1px solid #d1d5db',
                borderRadius: 8,
                padding: '0.65rem 0.75rem',
                fontSize: '0.9rem',
                fontFamily: 'inherit',
                marginBottom: '1rem',
              }}
            />
            <button
              type="submit"
              disabled={submitting}
              style={{
                background: submitting ? '#93c5fd' : BTN_BLUE,
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                padding: '0.65rem 1.5rem',
                fontSize: '0.95rem',
                fontWeight: 600,
                cursor: submitting ? 'wait' : 'pointer',
              }}
            >
              {submitting ? 'Submitting…' : 'Submit Request'}
            </button>
          </form>
        </div>
      )}
    </div>
  );
}
